/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * A metric reported over the vendor's four trailing windows.
 */
export interface CompanyRateWindowSchema {
  rate_3_month?: number | null;
  rate_6_month?: number | null;
  rate_12_month?: number | null;
  rate_24_month?: number | null;
}
